export default __webpack_public_path__ + "static/107991-4ee87511189fd9e12346b9085b028fa5.jpg";